import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'requiredStar',
    (theme, [hasVn]) => `
		display: block;
		position: absolute;
		top: 3px;
		${hasVn ? 'left: 0' : 'right: 0'};
		font-size: 12px;
		line-height: 12px;
		color: ${theme.color.semantic.warning};
	`
  ]
]);
